(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SearchClient", [], factory);
	else if(typeof exports === 'object')
		exports["SearchClient"] = factory();
	else
		root["SearchClient"] = factory();
})(typeof self !== "undefined" ? self : this, function() {
return 